import gql from "graphql-tag";

export const CARTLINES_ADD = gql`
  mutation cartLinesAdd($cartId: ID! , $lines: [CartLineInput]!) {
    cartLineAdd(cartId: $cartId, lines: $lines) {
      cart {
        token
        quantity
        forMgs
        messages {
          level
          message
        }
      }
      errors {
        field
        message
      }
    }
  }
`;

export const CART_CREATE = gql`
  mutation cartCreate($lines: [CartLineInput], $forMgs: Boolean) {
    cartCreate(lines: $lines, forMgs: $forMgs) {
      cart {
        token
        quantity
        forMgs
      }
      errors {
        field
        message
      }
    }
  }
`;

export const PRODUCT_SHARE = gql`
  query productShare($id: ID!) {
    productShare(id: $id) 
  }
`;

